'use strict';

module.exports = {
    default: 'default',
    test: 'test',
};
